import dict from '../../dictionary';
import cData from '../../reducedData.json';
// import dataByPHU from '../../dataByPHU.json';
import trans from '../../translations.json';
import Icon from '../../ds/icons/svg/ontario-icon-new-window.svg';
import IconChevronDown from '../../ds/icons/svg/ontario-icon-dropdown-arrow.svg';

const getPopupContent = (featureName, lang, mode, isPerCapita) => {
  if (mode === dict.phu) {
    return getPopupContentPhu(featureName, lang, mode, isPerCapita);
  } else {
    return getPopupContentFsa(featureName, lang, mode, isPerCapita);
  }
};

const getPopupContentPhu = (phuNameEn, lang, mode, isPerCapita) => {
  const phuData = cData.dataPHU[phuNameEn];
  let data = [
    phuData[dict.NotResolved],
    phuData[dict.resolved],
    phuData[dict.deaths],
    phuData[dict.NotResolved] +
      phuData[dict.resolved] +
      phuData[dict.deaths],
    phuData[dict.new],
    phuData[dict.yesterday],
  ];

  if (isPerCapita) {
    data = data.map((datapoint) =>
      datapoint !== 0
        ? ((datapoint / phuData[dict.PHU_pop]) * 100000).toFixed(2)
        : datapoint,
    );
  }
  function getIcon(data) {
    if (
      data[4].toLocaleString() === '0.00' ||
      data[4].toLocaleString() === '0'
    ) {
      return 'None';
    } else if (data[4] < 0) {
      return `<img style="margin-right: -5px;" src=${IconChevronDown}></img> ${Math.abs(
        data[4],
      ).toLocaleString()} `;
    } else if (data[4] > 0) {
      return `<img src=${IconChevronDown}  style="transform: rotate(180deg);"></img>${Math.abs(
        data[4],
      ).toLocaleString()}`;
    } else {
      return 'None';
    }
  }

  // set the popup content
  const popupContent = `<Popup>
      <b>${trans.PHU[phuNameEn][lang]}</b>
      ${
        phuData
          ? `<p>
          ${trans.viewModes.new[lang]}: ${getIcon(data)} 
          <br />
        ${
          trans.stacked.positive[lang]
        }: ${data[0]
              .toLocaleString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} <br />
        ${
          trans.stacked.resolved[lang]
        }: ${data[1]
              .toLocaleString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} <br />
        ${
          trans.stacked.deaths[lang]
        }: ${data[2]
              .toLocaleString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} <br />
        ${
          trans.viewModes.all[lang]
        }: ${data[3]
              .toLocaleString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} <br />
       
        </p>
        <p>${
          trans.stacked.linkA[lang] + ', '
        }<a target='_blank' href='${trans.phuLinks[phuNameEn]}'>
        ${trans.stacked.linkB[lang]}</a><a target='_blank' href='${
              trans.phuLinks[phuNameEn]
            }'><img style="width: 18px; height: 18px;"
            src='${Icon}'
          /></a></p>`
          : trans.heatmap.phuDNE[lang]
      }
      </Popup>`;

  return popupContent;
};

const getPopupContentFsa = (fsaName, lang, mode, isPerCapita) => {
  const fsaData = cData.dataFSA[fsaName];
  /**
 *  "FSA": "K2P",
            "ACTIVE_CASES": "3",
            "RATE_PER_100K": "16.8"
 */
  // set the popup content
  const popupContent = `<Popup>
      <b>${fsaName}</b>
      <p>
        ${trans.heatmap.active[lang]}: ${
    fsaData?.ACTIVE_CASES || 0
  } (${fsaData?.RATE_PER_100K || 0} per 100k people) <br />
      
        </p>
      </Popup>`;

  return popupContent;
};

export { getPopupContent };
